export const currenciesHeaders = [
  { key: "currency_name", label: "Currency", width: 4 },
  { key: "format", label: "Format", width: 4 },
  { key: "last_updated", label: "Last Updated", width: 1 },
];